import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import axiosInstance from '../../../../../services/AxiosInstance';
import Api from '../../../../../constants/Api';
import { formatDreGroup } from './DreGroupFormat';

const CategorySelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);
  // Grupos do DRE que não fazem sentido no contexto (ex.: Receita numa saída). A lista vai
  // como texto para o efeito não recarregar a cada render por causa de um array novo.
  const excludedGroups = (props.excludeDreGroups || []).join(',');

  useEffect(() => {
    
    function findAll() {
      setEntities([]);

      axiosInstance.get(Api.cash_flow.category)
        .then(response => {
          let entities = [];

          for (var i = 0; i < response.data.length; i++) {
            const dreGroup = response.data[i].dreGroup;
            if (dreGroup && excludedGroups.split(',').includes(dreGroup)) {
              continue;
            }
            entities.push(
              {
                value: response.data[i].id,
                label: response.data[i].name,
                dreGroup: dreGroup,
                dreGroupLabel: formatDreGroup(dreGroup)
              }
            );

            setEntities(entities);
          }
        });
    }

    findAll();
  }, [t, excludedGroups]);

  return (
    <CustomSelect options={entities} error={props.error} value={props.value} onChange={props.onChange} isClearable placeholder={t("select")} isDisabled={props.isDisabled} />
  )
}

export default CategorySelect;
